<template>
  <div 
    class="workflow-step-node"
    :class="[
      nodeData.type?.toLowerCase() || 'default',
      { selected: selected }
    ]"
  >
    <div class="node-header">
      <i :class="getStepIcon(nodeData.type)"></i>
      <span class="node-label">{{ nodeData.label || 'Untitled Step' }}</span>
    </div>
    <div v-if="nodeData.description" class="node-description">
      {{ nodeData.description }}
    </div>
    <div v-if="automatedCheck" class="node-check">
      <span class="check-name">{{ automatedCheck.name }}</span>
      <span 
        v-if="automatedCheck.severity" 
        class="severity-badge"
        :class="automatedCheck.severity.toLowerCase()"
      >
        {{ automatedCheck.severity }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowStepNode',
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nodeData() {
      return {
        type: this.data.type || 'CUSTOM',
        label: this.data.label || 'Untitled Step',
        description: this.data.description,
        automated_check: this.data.automated_check,
        automatedCheck: this.data.automatedCheck
      };
    },
    automatedCheck() {
      return this.data.automatedCheck;
    }
  },
  methods: {
    getStepIcon(type) {
      const icons = {
        'ANALYSIS': 'fas fa-search',
        'VALIDATION': 'fas fa-check-circle',
        'SUMMARY': 'fas fa-file-alt',
        'CUSTOM': 'fas fa-cog'
      };
      return icons[type] || 'fas fa-cog';
    }
  }
};
</script>

<style scoped>
.workflow-step-node {
  padding: 10px;
  border-radius: 4px;
  background: white;
  border: 2px solid #e2e8f0;
  min-width: 150px;
}

.workflow-step-node.default {
  border-color: #94a3b8;
}

.node-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.node-label {
  font-weight: 500;
  flex: 1;
}

.node-severity {
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 0.75rem;
}

.node-severity.high {
  background: #fee2e2;
  color: #991b1b;
}

.node-severity.medium {
  background: #fef3c7;
  color: #92400e;
}

.node-severity.low {
  background: #dbeafe;
  color: #1e40af;
}

.node-severity.default {
  background: #f1f5f9;
  color: #64748b;
}

.node-description {
  margin-top: 8px;
  font-size: 0.875rem;
  color: #64748b;
}

.workflow-step-node.selected {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}
</style> 